import { Link } from "react-router-dom";
import { Button, useTheme } from "@monolith-forensics/monolith-ui";

// Details-page state for an unknown asset uuid. GET /assets/:uuid gives a true
// 404 (unlike the list-query details pages that conflate 404 with 403), so the
// copy can honestly say "not found" instead of "no access". Same panel shape
// as the Evidence/Storage versions; extracting a shared component is a
// follow-up outside ENG-1382.
export const LabAssetNotFound: React.FC = () => {
  const theme = useTheme();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: 15,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 5,
        width: "fit-content",
        margin: "auto",
        marginTop: 100,
      }}
    >
      <div style={{ fontSize: 24, fontWeight: "bold" }}>Asset not found.</div>
      <div style={{ color: theme.palette.text.secondary, fontSize: 18 }}>
        It may have been deleted, or the link may be incorrect.
      </div>
      <Link to="/assets">
        <Button
          variant="contained"
          color="primary"
          style={{ marginTop: 20 }}
          size="xs"
        >
          Return To Assets List
        </Button>
      </Link>
    </div>
  );
};
